import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var StudiesIcon = function(props) {
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 36",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("circle", {
                cx: "18",
                cy: "18",
                r: "16.5",
                fill: "white",
                stroke: "#FFDF00",
                "stroke-width": "3"
            }),
            /*#__PURE__*/ _jsx("mask", {
                id: "mask0_66_91",
                maskUnits: "userSpaceOnUse",
                x: "7",
                y: "8",
                width: "20",
                height: "20",
                children: /*#__PURE__*/ _jsx("rect", {
                    x: "7",
                    y: "8",
                    width: "20",
                    height: "20",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ _jsx("g", {
                mask: "url(#mask0_66_91)",
                children: /*#__PURE__*/ _jsx("path", {
                    d: "M18.1667 26L12.3333 22.8333V17.8333L9 16L18.1667 11L27.3333 16V22.6667H25.6667V16.9167L24 17.8333V22.8333L18.1667 26ZM18.1667 19.0833L23.875 16L18.1667 12.9167L12.4583 16L18.1667 19.0833ZM18.1667 24.1042L22.3333 21.8542V18.7083L18.1667 21L14 18.7083V21.8542L18.1667 24.1042Z",
                    fill: "#FFDF00"
                })
            })
        ]
    }));
};
